<xux-widget-boilerplate [field]="field">
  <div class="input-holder">
    <input
      type="date"
      [formControl]="field?.control"
      [readonly]="field?.readonly"
      [min]="field?.minimum || (field?.widgetData?.minimumObs | async)"
      [max]="field?.maximum || (field?.widgetData?.maximumObs | async)"
    />
    <span class="datepicker-icon-wrapper open-icon">
      <xux-icon class="icon-calendar" icon="icon-calendar"></xux-icon>
    </span>
  </div>
</xux-widget-boilerplate>
